import work from './work.json';
import vacation from './vacations.json';
import money from './money.json';
import food from './food.json';
import Body from './body.json';
import basicA1 from './basicA1.json';
import basicA2 from './basicA2.json';
import basicb1 from './basicb1.json';

export const VocabularyIdioms = [
  work,
  vacation,
  money,
  food,
  Body,
  basicA1,
  basicA2,
  basicb1
];